module.exports = __webpack_public_path__ + "img/case-studies5.eed39ecd.jpg";